package com.exura.components.dialogs

import androidx.compose.runtime.Composable
import com.exura.components.pageTypography.ExuraBodyHeaderTextVariant
import com.exura.components.pageTypography.ExuraTextStyle
import com.exura.components.pageTypography.ExuraUnderwriteTextVariant
import com.exura.components.qr.QRCodeImage
import com.exura.features.publicplans.publicPlansLocalization
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier

@Composable
fun QrCodeDialogContent(
    data: String,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(Dimens.dialogContentGap),
    ) {
        QRCodeImage(
            data = data,
            size = Dimens.qrImageSizeLarge,
            foregroundColor = "000000",
            backgroundColor = "ffffff"
        )

        SpanText(
            modifier = ExuraTextStyle.toModifier(ExuraBodyHeaderTextVariant),
            text = publicPlansLocalization.current.qr.scanCode
        )

        SpanText(
            modifier = ExuraTextStyle.toModifier(ExuraUnderwriteTextVariant),
            text = publicPlansLocalization.current.qr.clickAround
        )
    }
}
